/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * Демо-сервисы СамИС
 * Программный интерфейс для различных демо-сервисов АО Самара-Информспутник
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */

import * as url from "url";
import * as isomorphicFetch from "isomorphic-fetch";
import { Configuration } from "./configuration";

const BASE_PATH = "https://rk.geosamara.ru/geosamara-demo-services/1.0.0/".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected fetch: FetchAPI = isomorphicFetch) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
}

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name = "RequiredError"
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 * 
 * @export
 * @interface Error
 */
export interface Error {
    /**
     * 
     * @type {string}
     * @memberof Error
     */
    code?: string;
    /**
     * 
     * @type {string}
     * @memberof Error
     */
    message?: string;
}
/**
 * 
 * @export
 * @interface FiasAddressElement
 */
export interface FiasAddressElement {
    /**
     * 
     * @type {string}
     * @memberof FiasAddressElement
     */
    guid?: string;
    /**
     * 
     * @type {string}
     * @memberof FiasAddressElement
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof FiasAddressElement
     */
    typename?: string;
    /**
     * 
     * @type {number}
     * @memberof FiasAddressElement
     */
    level?: number;
    /**
     * 
     * @type {any}
     * @memberof FiasAddressElement
     */
    geometry?: any;
}
/**
 * 
 * @export
 * @interface FiasHierarchy
 */
export interface FiasHierarchy {
    /**
     * 
     * @type {number}
     * @memberof FiasHierarchy
     */
    childCount?: number;
    /**
     * 
     * @type {number}
     * @memberof FiasHierarchy
     */
    returned?: number;
    /**
     * 
     * @type {Array<FiasAddressElement>}
     * @memberof FiasHierarchy
     */
    childs?: Array<FiasAddressElement>;
}
/**
 * 
 * @export
 * @interface Region
 */
export interface Region {
    /**
     * 
     * @type {string}
     * @memberof Region
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Region
     */
    urlpart?: string;
    /**
     * 
     * @type {number}
     * @memberof Region
     */
    code?: number;
    /**
     * 
     * @type {number}
     * @memberof Region
     */
    lat?: number;
    /**
     * 
     * @type {number}
     * @memberof Region
     */
    lon?: number;
    /**
     * 
     * @type {number}
     * @memberof Region
     */
    zoom?: number;
}
/**
 * 
 * @export
 */
export type Regions = Array<Region>
/**
 * 
 * @export
 * @interface ShortLeadStats
 */
export interface ShortLeadStats {
    /**
     * 
     * @type {Array<string>}
     * @memberof ShortLeadStats
     */
    modules?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ShortLeadStats
     */
    actions?: number;
    /**
     * 
     * @type {number}
     * @memberof ShortLeadStats
     */
    days?: number;
}
/**
 * FiasGeocodedApi - fetch parameter creator
 * @export
 */
export const FiasGeocodedApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Возвращает геометрию объекта по идентификатору
         * @summary Метод для получения геометрии ФИАС/ГАР
         * @param {string} region код региона
         * @param {string} guid идентификатор элемента адресации
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiasGeometry(region: string, guid: string | null | undefined, options: any = {}): FetchArgs {
            // verify required parameter 'region' is not null or undefined
            if (region === null || region === undefined) {
                throw new RequiredError('region','Required parameter region was null or undefined when calling getFiasGeometry.');
            }
            // verify required parameter 'guid' is not null or undefined
            // if (guid === null || guid === undefined) {
            //     throw new RequiredError('guid','Required parameter guid was null or undefined when calling getFiasGeometry.');
            // }
            const localVarPath = `/fias/geometry`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (region !== undefined) {
                localVarQueryParameter['region'] = region;
            }

            if (guid !== undefined) {
                localVarQueryParameter['guid'] = guid;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Возвращает элементы адресации, найденные по нескольким условиям
         * @summary Метод для поиска по иерархии ФИАС/ГАР
         * @param {string} region код региона
         * @param {string} [parent] идентификатор родительского элемента
         * @param {string} [namepart] часть названия
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiasHierarchy(region: string, parent?: string, namepart?: string, options: any = {}): FetchArgs {
            // verify required parameter 'region' is not null or undefined
            if (region === null || region === undefined) {
                throw new RequiredError('region','Required parameter region was null or undefined when calling getFiasHierarchy.');
            }
            const localVarPath = `/fias/hierarchy`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (region !== undefined) {
                localVarQueryParameter['region'] = region;
            }

            if (parent !== undefined) {
                localVarQueryParameter['parent'] = parent;
            }

            if (namepart !== undefined) {
                localVarQueryParameter['namepart'] = namepart;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FiasGeocodedApi - functional programming interface
 * @export
 */
export const FiasGeocodedApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Возвращает геометрию объекта по идентификатору
         * @summary Метод для получения геометрии ФИАС/ГАР
         * @param {string} region код региона
         * @param {string} guid идентификатор элемента адресации
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiasGeometry(region: string, guid: string | null | undefined, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FiasAddressElement> {
            const localVarFetchArgs = FiasGeocodedApiFetchParamCreator(configuration).getFiasGeometry(region, guid, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Возвращает элементы адресации, найденные по нескольким условиям
         * @summary Метод для поиска по иерархии ФИАС/ГАР
         * @param {string} region код региона
         * @param {string} [parent] идентификатор родительского элемента
         * @param {string} [namepart] часть названия
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiasHierarchy(region: string, parent?: string, namepart?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<FiasHierarchy> {
            const localVarFetchArgs = FiasGeocodedApiFetchParamCreator(configuration).getFiasHierarchy(region, parent, namepart, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * FiasGeocodedApi - factory interface
 * @export
 */
export const FiasGeocodedApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Возвращает геометрию объекта по идентификатору
         * @summary Метод для получения геометрии ФИАС/ГАР
         * @param {string} region код региона
         * @param {string} guid идентификатор элемента адресации
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiasGeometry(region: string, guid: string, options?: any) {
            return FiasGeocodedApiFp(configuration).getFiasGeometry(region, guid, options)(fetch, basePath);
        },
        /**
         * Возвращает элементы адресации, найденные по нескольким условиям
         * @summary Метод для поиска по иерархии ФИАС/ГАР
         * @param {string} region код региона
         * @param {string} [parent] идентификатор родительского элемента
         * @param {string} [namepart] часть названия
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiasHierarchy(region: string, parent?: string, namepart?: string, options?: any) {
            return FiasGeocodedApiFp(configuration).getFiasHierarchy(region, parent, namepart, options)(fetch, basePath);
        },
    };
};

/**
 * FiasGeocodedApi - object-oriented interface
 * @export
 * @class FiasGeocodedApi
 * @extends {BaseAPI}
 */
export class FiasGeocodedApi extends BaseAPI {
    /**
     * Возвращает геометрию объекта по идентификатору
     * @summary Метод для получения геометрии ФИАС/ГАР
     * @param {string} region код региона
     * @param {string} guid идентификатор элемента адресации
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiasGeocodedApi
     */
    public getFiasGeometry(region: string, guid: string | null | undefined, options?: any) {
        return FiasGeocodedApiFp(this.configuration).getFiasGeometry(region, guid, options)(this.fetch, this.basePath);
    }

    /**
     * Возвращает элементы адресации, найденные по нескольким условиям
     * @summary Метод для поиска по иерархии ФИАС/ГАР
     * @param {string} region код региона
     * @param {string} [parent] идентификатор родительского элемента
     * @param {string} [namepart] часть названия
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FiasGeocodedApi
     */
    public getFiasHierarchy(region: string, parent?: string, namepart?: string, options?: any) {
        return FiasGeocodedApiFp(this.configuration).getFiasHierarchy(region, parent, namepart, options)(this.fetch, this.basePath);
    }

}
/**
 * LeadContactsApi - fetch parameter creator
 * @export
 */
export const LeadContactsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Вызывается, чтобы проверить, насколько уже известен системе этот лид, возвращает краткую статистику его активности
         * @summary Метод для проверки лида
         * @param {string} metricID идентификатор пользователя из веб-счетчика
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadContact(metricID: string, options: any = {}): FetchArgs {
            // verify required parameter 'metricID' is not null or undefined
            if (metricID === null || metricID === undefined) {
                throw new RequiredError('metricID','Required parameter metricID was null or undefined when calling getLeadContact.');
            }
            const localVarPath = `/contact`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (metricID !== undefined) {
                localVarQueryParameter['metricID'] = metricID;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Для установления взаимосвязи между выбранным регионом, параметрами адресной строки и позиционированием карты
         * @summary Справочник регионов
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegions(options: any = {}): FetchArgs {
            const localVarPath = `/regions`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Вызывается, когда лид совершил какое-то осмысленное действие, чтобы зафиксировать для внутренней статистики
         * @summary Метод для передачи действия пользователя
         * @param {string} metricID идентификатор пользователя из веб-счетчика
         * @param {string} module модуль, в котором совершено действие
         * @param {string} type тип действия
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAction(metricID: string, module: string, type: string, options: any = {}): FetchArgs {
            // verify required parameter 'metricID' is not null or undefined
            if (metricID === null || metricID === undefined) {
                throw new RequiredError('metricID','Required parameter metricID was null or undefined when calling postAction.');
            }
            // verify required parameter 'module' is not null or undefined
            if (module === null || module === undefined) {
                throw new RequiredError('module','Required parameter module was null or undefined when calling postAction.');
            }
            // verify required parameter 'type' is not null or undefined
            if (type === null || type === undefined) {
                throw new RequiredError('type','Required parameter type was null or undefined when calling postAction.');
            }
            const localVarPath = `/action`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (metricID !== undefined) {
                localVarQueryParameter['metricID'] = metricID;
            }

            if (module !== undefined) {
                localVarQueryParameter['module'] = module;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Вызывается, когда лид предоставил телефон или адрес почты и совершил осмысленное действие
         * @summary Метод для передачи контактов лида
         * @param {string} metricID идентификатор пользователя из веб-счетчика
         * @param {string} contact телефон, адрес почты или еще какой контакт
         * @param {string} [company] организация, в которой работает лид
         * @param {string} [position] должность лида
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLeadContact(metricID: string, contact: string, company?: string, position?: string, options: any = {}): FetchArgs {
            // verify required parameter 'metricID' is not null or undefined
            if (metricID === null || metricID === undefined) {
                throw new RequiredError('metricID','Required parameter metricID was null or undefined when calling postLeadContact.');
            }
            // verify required parameter 'contact' is not null or undefined
            if (contact === null || contact === undefined) {
                throw new RequiredError('contact','Required parameter contact was null or undefined when calling postLeadContact.');
            }
            const localVarPath = `/contact`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (metricID !== undefined) {
                localVarQueryParameter['metricID'] = metricID;
            }

            if (contact !== undefined) {
                localVarQueryParameter['contact'] = contact;
            }

            if (company !== undefined) {
                localVarQueryParameter['company'] = company;
            }

            if (position !== undefined) {
                localVarQueryParameter['position'] = position;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LeadContactsApi - functional programming interface
 * @export
 */
export const LeadContactsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Вызывается, чтобы проверить, насколько уже известен системе этот лид, возвращает краткую статистику его активности
         * @summary Метод для проверки лида
         * @param {string} metricID идентификатор пользователя из веб-счетчика
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadContact(metricID: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ShortLeadStats> {
            const localVarFetchArgs = LeadContactsApiFetchParamCreator(configuration).getLeadContact(metricID, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Для установления взаимосвязи между выбранным регионом, параметрами адресной строки и позиционированием карты
         * @summary Справочник регионов
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegions(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Regions> {
            const localVarFetchArgs = LeadContactsApiFetchParamCreator(configuration).getRegions(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Вызывается, когда лид совершил какое-то осмысленное действие, чтобы зафиксировать для внутренней статистики
         * @summary Метод для передачи действия пользователя
         * @param {string} metricID идентификатор пользователя из веб-счетчика
         * @param {string} module модуль, в котором совершено действие
         * @param {string} type тип действия
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAction(metricID: string, module: string, type: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = LeadContactsApiFetchParamCreator(configuration).postAction(metricID, module, type, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Вызывается, когда лид предоставил телефон или адрес почты и совершил осмысленное действие
         * @summary Метод для передачи контактов лида
         * @param {string} metricID идентификатор пользователя из веб-счетчика
         * @param {string} contact телефон, адрес почты или еще какой контакт
         * @param {string} [company] организация, в которой работает лид
         * @param {string} [position] должность лида
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLeadContact(metricID: string, contact: string, company?: string, position?: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = LeadContactsApiFetchParamCreator(configuration).postLeadContact(metricID, contact, company, position, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * LeadContactsApi - factory interface
 * @export
 */
export const LeadContactsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * Вызывается, чтобы проверить, насколько уже известен системе этот лид, возвращает краткую статистику его активности
         * @summary Метод для проверки лида
         * @param {string} metricID идентификатор пользователя из веб-счетчика
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLeadContact(metricID: string, options?: any) {
            return LeadContactsApiFp(configuration).getLeadContact(metricID, options)(fetch, basePath);
        },
        /**
         * Для установления взаимосвязи между выбранным регионом, параметрами адресной строки и позиционированием карты
         * @summary Справочник регионов
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegions(options?: any) {
            return LeadContactsApiFp(configuration).getRegions(options)(fetch, basePath);
        },
        /**
         * Вызывается, когда лид совершил какое-то осмысленное действие, чтобы зафиксировать для внутренней статистики
         * @summary Метод для передачи действия пользователя
         * @param {string} metricID идентификатор пользователя из веб-счетчика
         * @param {string} module модуль, в котором совершено действие
         * @param {string} type тип действия
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postAction(metricID: string, module: string, type: string, options?: any) {
            return LeadContactsApiFp(configuration).postAction(metricID, module, type, options)(fetch, basePath);
        },
        /**
         * Вызывается, когда лид предоставил телефон или адрес почты и совершил осмысленное действие
         * @summary Метод для передачи контактов лида
         * @param {string} metricID идентификатор пользователя из веб-счетчика
         * @param {string} contact телефон, адрес почты или еще какой контакт
         * @param {string} [company] организация, в которой работает лид
         * @param {string} [position] должность лида
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postLeadContact(metricID: string, contact: string, company?: string, position?: string, options?: any) {
            return LeadContactsApiFp(configuration).postLeadContact(metricID, contact, company, position, options)(fetch, basePath);
        },
    };
};

/**
 * LeadContactsApi - object-oriented interface
 * @export
 * @class LeadContactsApi
 * @extends {BaseAPI}
 */
export class LeadContactsApi extends BaseAPI {
    /**
     * Вызывается, чтобы проверить, насколько уже известен системе этот лид, возвращает краткую статистику его активности
     * @summary Метод для проверки лида
     * @param {string} metricID идентификатор пользователя из веб-счетчика
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadContactsApi
     */
    public getLeadContact(metricID: string, options?: any) {
        return LeadContactsApiFp(this.configuration).getLeadContact(metricID, options)(this.fetch, this.basePath);
    }

    /**
     * Для установления взаимосвязи между выбранным регионом, параметрами адресной строки и позиционированием карты
     * @summary Справочник регионов
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadContactsApi
     */
    public getRegions(options?: any) {
        return LeadContactsApiFp(this.configuration).getRegions(options)(this.fetch, this.basePath);
    }

    /**
     * Вызывается, когда лид совершил какое-то осмысленное действие, чтобы зафиксировать для внутренней статистики
     * @summary Метод для передачи действия пользователя
     * @param {string} metricID идентификатор пользователя из веб-счетчика
     * @param {string} module модуль, в котором совершено действие
     * @param {string} type тип действия
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadContactsApi
     */
    public postAction(metricID: string, module: string, type: string, options?: any) {
        return LeadContactsApiFp(this.configuration).postAction(metricID, module, type, options)(this.fetch, this.basePath);
    }

    /**
     * Вызывается, когда лид предоставил телефон или адрес почты и совершил осмысленное действие
     * @summary Метод для передачи контактов лида
     * @param {string} metricID идентификатор пользователя из веб-счетчика
     * @param {string} contact телефон, адрес почты или еще какой контакт
     * @param {string} [company] организация, в которой работает лид
     * @param {string} [position] должность лида
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LeadContactsApi
     */
    public postLeadContact(metricID: string, contact: string, company?: string, position?: string, options?: any) {
        return LeadContactsApiFp(this.configuration).postLeadContact(metricID, contact, company, position, options)(this.fetch, this.basePath);
    }

}
